module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "asdan-background"
  }, [_c('common-header'), _vm._v(" "), (_vm.Role == 'student' && _vm.tips !== '') ? _c('el-row', {
    staticClass: "mt-20",
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-alert', {
    attrs: {
      "title": _vm.tips,
      "type": "warning",
      "show-icon": ""
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    staticClass: "main",
    attrs: {
      "type": "flex",
      "justify": "center",
      "id": "main"
    }
  }, [_c('el-col', {
    staticClass: "main-content mt-20 mb-20",
    attrs: {
      "span": 22
    }
  }, [_c('div', {
    staticClass: "main-left"
  }, [_c('div', {
    staticClass: "pt-20"
  }, _vm._l((_vm.$router.options.routes), function(roleRoot, index) {
    return (_vm.matchedPath(roleRoot)) ? _c('el-menu', {
      key: index,
      staticClass: "el-menu-vertical-demo",
      attrs: {
        "default-active": _vm.getMenuActive(),
        "router": ""
      }
    }, _vm._l((roleRoot.children), function(child, index) {
      return (!child.hiddenFromMenu) ? _c('el-menu-item', {
        key: index,
        attrs: {
          "index": roleRoot.path + '/' + child.path
        }
      }, [_c('i', {
        class: child.iconCls
      }), _vm._v(" "), _c('span', {
        staticClass: "ml-5"
      }), _vm._v(_vm._s(child.name) + "\n                        ")]) : _vm._e()
    }), 1) : _vm._e()
  }), 1)]), _vm._v(" "), _c('div', {
    staticClass: "main-right pl-20 pr-20 mt-20"
  }, [_c('div', {
    staticClass: "content-container"
  }, [_c('router-view', {
    on: {
      "setTips": _vm.handleTips
    }
  })], 1)])])], 1), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copyright text-center pb-15"
  }, [_c('p', {
    staticClass: "gary"
  }, [_vm._v("© 2020 ASDAN China.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fb1980c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 619
// module chunks = 1